export class AreaGate {
    id: number;
    name: string;

    constructor(areaGate: any) {
        this.id = areaGate.id;
        this.name = areaGate.name;
    }
}